var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { attrs: { title: "Reporte Histórico de Procesos" } },
        [
          _vm._v(
            "      \n    Total: " + _vm._s(_vm.totalCount) + " procesos\n    "
          ),
          _c("form", { staticClass: "form-graphic" }, [
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col sm:w-1/4 w-full" },
                [
                  _vm._v("\n          Fecha de inicio:\n          "),
                  _c("datepicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "pickadate-limits",
                    attrs: {
                      language: _vm.languages[_vm.language],
                      name: "dateStart",
                    },
                    model: {
                      value: _vm.form.dateStart,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dateStart", $$v)
                      },
                      expression: "form.dateStart",
                    },
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("dateStart"),
                          expression: "errors.has('dateStart')",
                        },
                      ],
                      staticClass: "text-danger text-sm",
                    },
                    [_vm._v("Requerido")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col sm:w-1/4 w-full" },
                [
                  _vm._v("\n          Fecha final:\n          "),
                  _c("datepicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "pickadate-limits",
                    attrs: {
                      language: _vm.languages[_vm.language],
                      name: "dateEnd",
                    },
                    model: {
                      value: _vm.form.dateEnd,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dateEnd", $$v)
                      },
                      expression: "form.dateEnd",
                    },
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("dateEnd"),
                          expression: "errors.has('dateEnd')",
                        },
                      ],
                      staticClass: "text-danger text-sm",
                    },
                    [_vm._v("Requerido")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col sm:w-1/4 w-full" },
                [
                  _vm._v("\n          Ciudades: "),
                  _c("v-select", {
                    attrs: { options: _vm.cities, name: "project.city_id" },
                    model: {
                      value: _vm.form.city_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "city_id", $$v)
                      },
                      expression: "form.city_id",
                    },
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("city"),
                          expression: "errors.has('city')",
                        },
                      ],
                      staticClass: "text-danger text-sm",
                    },
                    [_vm._v("Requerido")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col sm:w-1/4 w-full" },
                [
                  _c("br"),
                  _c(
                    "vs-button",
                    {
                      staticClass: "block",
                      attrs: { type: "filled" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.submitForm.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Consultar")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          this.columnChart.chartOptions.xaxis.categories.length > 0 &&
          _vm.series.length > 0
            ? _c("vue-apex-charts", {
                ref: "chart",
                attrs: {
                  id: "chart",
                  type: "bar",
                  height: "350",
                  options: _vm.columnChart.chartOptions,
                  series: _vm.series,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }